module.exports = __webpack_public_path__ + "media/application/images/landing_header/underlay_04-712ed63d63145d1b3f375da85c5eafeb.png";